"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusIterable = exports.RefreshSourceSchema = exports.RefreshSourceIterable = void 0;
const zod_1 = require("zod");
exports.RefreshSourceIterable = ['glueCompletion', 'manual'];
exports.RefreshSourceSchema = zod_1.z.enum(exports.RefreshSourceIterable);
exports.StatusIterable = [
    'initializedConfig', // Created config for materialized view
    'initializedTable', // Created MV table but haven't populated with data
    'refreshInProgress',
    'refreshComplete',
    'deleted',
    'errorCreateTable',
    'errorRefreshData',
    'errorDeleteTableAndConfig',
];
//# sourceMappingURL=common.js.map